module.exports = __webpack_public_path__ + "img/img-dingzhi-s2-tuya.6bdea5c2.jpg";